// ABOUTME: The chevron of week navigation and collapsible blocks, pointing left until rotated by a class
// ABOUTME: Drawn in currentColor, gray-900 unless the caller sets a text colour, so it follows the theme

import type { FC } from "react"
import { cn } from "@shared/lib/utils"

export const ChevronIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-gray-900", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.707 14.707C12.8945 14.5195 12.9998 14.2651 12.9998 14C12.9998 13.7348 12.8945 13.4805 12.707 13.293L9.414 9.99998L12.707 6.70698C12.8892 6.51838 12.99 6.26578 12.9877 6.00358C12.9854 5.74138 12.8802 5.49057 12.6948 5.30516C12.5094 5.11975 12.2586 5.01458 11.9964 5.01231C11.7342 5.01003 11.4816 5.11082 11.293 5.29298L7.293 9.29298C7.10553 9.48051 7.00021 9.73482 7.00021 9.99998C7.00021 10.2651 7.10553 10.5195 7.293 10.707L11.293 14.707C11.4805 14.8945 11.7348 14.9998 12 14.9998C12.2652 14.9998 12.5195 14.8945 12.707 14.707Z"
        fill="currentColor"
      />
    </svg>
  )
}
